import { useEffect } from "react";
import { usePrevious } from "./use-previous.js";
function useFocusWhen(fn, focusableElement) {
  const val = fn();
  const previousVal = usePrevious(val);
  useEffect(() => {
    if (val && previousVal === false) {
      focusableElement?.current?.focus();
    }
  }, [val, previousVal, focusableElement]);
}
export {
  useFocusWhen
};
//# sourceMappingURL=use-focus-when.js.map
